import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../common_components/mdae-framework";
import { GET_BILL_DATA_CONFIGURATION } from "../services/get-bill-data-configuration";

export const SET_BILL_DATA_CONFIGURATION_FORM_DATA =
  "SET_BILL_DATA_CONFIGURATION_FORM_DATA";
export const TOGGLE_UPLOAD_BILL_DATA_POPUP = "TOGGLE_UPLOAD_BILL_DATA_POPUP";

export const defaultBillDataConfigurationFormData = {
  refBillDataConfigId: 0,
  clientId: 0,
  caseBillData1Name: "",
  caseBillData1ObjectCode: null,
  caseBillData1SaveInstance: false,
  caseBillData1UpdatedById: null,
  caseBillData1UpdatedBy: null,
  caseBillData1UpdatedDate: null,
  caseBillData2Name: "",
  caseBillData2ObjectCode: null,
  caseBillData2SaveInstance: false,
  caseBillData2UpdatedById: null,
  caseBillData2UpdatedBy: null,
  caseBillData2UpdatedDate: null,
  caseBillData3Name: "",
  caseBillData3ObjectCode: null,
  caseBillData3SaveInstance: false,
  caseBillData3UpdatedById: null,
  caseBillData3UpdatedBy: null,
  caseBillData3UpdatedDate: null,
  lineBillData1Name: "",
  lineBillData1ObjectCode: null,
  lineBillData1SaveInstance: false,
  lineBillData1UpdatedById: null,
  lineBillData1UpdatedBy: null,
  lineBillData1UpdatedDate: null,
  lineBillData2Name: "",
  lineBillData2ObjectCode: null,
  lineBillData2SaveInstance: false,
  lineBillData2UpdatedById: null,
  lineBillData2UpdatedBy: null,
  lineBillData2UpdatedDate: null,
  lineBillData3Name: "",
  lineBillData3ObjectCode: null,
  lineBillData3SaveInstance: false,
  lineBillData3UpdatedById: null,
  lineBillData3UpdatedBy: null,
  lineBillData3UpdatedDate: null,
  workingItem: null,
  createdBy: null,
  createdDate: null,
  updatedBy: null,
  updatedDate: null,
};

const initialState = {
  isLoading: false,
  billDataConfigurationFormData: defaultBillDataConfigurationFormData,
  billDataConfigObjectList: [],
  isUploadBillDataPopupVisible: false,
  totalRecordsinFile: 0,
  totalRecordsinFileWithError: 0,
  billDataList: [],
};

export default function(state = initialState, action: any) {
  let newState;
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_BILL_DATA_CONFIGURATION)(action)) {
        return {
          ...state,
          billDataConfigObjectList: [],
          billDataConfigurationFormData: defaultBillDataConfigurationFormData,
          isLoading: false,
        };
      }
      if (isAsyncComplete(GET_BILL_DATA_CONFIGURATION)(action)) {
        const response = action.response;
        return {
          ...state,
          billDataConfigObjectList: response.billDataConfigObjectList,
          billDataConfigurationFormData: {
            ...defaultBillDataConfigurationFormData,
            ...response.billDataConfiguration,
          },
          isLoading: true,
        };
      }  

      return state;

    case SET_BILL_DATA_CONFIGURATION_FORM_DATA:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = {
          ...newState,
          billDataConfigurationFormData: {
            ...newState.billDataConfigurationFormData,
            ...action.data.billDataConfigurationFormData,
          },
        };
      }
      return newState;

    case TOGGLE_UPLOAD_BILL_DATA_POPUP:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    default:
      return state;
  }
}
